import { AxiosError } from 'axios';
import { FileUploadSetting } from 'backend';
import { HandleUploadFileErrorResponse } from 'fetcher';
import { FileUploadResultFailure, FILE_UPLOAD_RESULT_TYPE } from './models';

export const handleError = (
  e: unknown,
  { errorMessages }: FileUploadSetting,
): FileUploadResultFailure => {
  const errorOrAxiosError = e as
    | AxiosError<HandleUploadFileErrorResponse>
    | Error;

  if ('response' in errorOrAxiosError) {
    const error =
      errorOrAxiosError as AxiosError<HandleUploadFileErrorResponse>;
    const errorType = error.response?.data?.error.type;
    const errorMessage =
      (errorType && errorMessages[errorType]) ||
      errorMessages.UPLOAD_ERROR ||
      '';
    return {
      type: FILE_UPLOAD_RESULT_TYPE.failure,
      errorMessages: [errorMessage],
    };
  }
  const errorMessage = errorMessages.UPLOAD_ERROR || '';
  return {
    type: FILE_UPLOAD_RESULT_TYPE.failure,
    errorMessages: [errorMessage],
  };
};
